import { MaxWidth } from "components/MaxWidth";
import { Button } from "components/Button";
import { Spacing } from "components/Spacing";
import { TYPE_LINK, SMALL, MEDIUM } from "shared/constants";
import styles from "./CenteredContentSection.module.css";

export const CenteredContentSectionContainer = ({ title, body, button }) => (
  <Spacing size={MEDIUM}>
    <MaxWidth size={SMALL}>
      <CenteredContentSection title={title} body={body} button={button} />
    </MaxWidth>
  </Spacing>
);

export const CenteredContentSection = ({ title, body, button }) => (
  <div className={styles.container}>
    {title && <h2 className={styles.title}>{title}</h2>}
    {body && <p className={styles.body}>{body}</p>}
    {button && (
      <div className={styles.buttonWrapper}>
        <Button type={TYPE_LINK} {...button}>
          {button.label}
        </Button>
      </div>
    )}
  </div>
);
